import { render, staticRenderFns } from "./TgMemberReviewDialog.vue?vue&type=template&id=6102210b"
import script from "./TgMemberReviewDialog.vue?vue&type=script&lang=js"
export * from "./TgMemberReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports